import { render } from "./logoGridTemplate.vue?vue&type=template&id=69ccfe05"
import script from "./logoGridTemplate.vue?vue&type=script&lang=js"
export * from "./logoGridTemplate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__